const isOnlyNumbers = (value: string): boolean => {
  return /^[0-9,]*\.?[0-9]*$/.test(value);
};

export default isOnlyNumbers;
